import workflowContainer from "../../../../containers/workflow";
import Campaigns from "./Campaigns";

export default workflowContainer(Campaigns);
